import PropTypes from 'prop-types';
import React from 'react';
import { Divider, Icon, List, Table } from 'antd';
import { withTranslation } from 'react-i18next';

import Link from '../../../components/link';
import { LoadingIcon } from '../../../components/loading';
import { BalanceDisplayer } from '../../../components/balance-displayer/BalanceDisplayer';
import './list.scss';

const accountType = (productId) => {
  const suffix = productId.substr(productId.lastIndexOf('_') + 1, productId.length - productId.lastIndexOf('_'));
  switch (suffix) {
    case 'b':
      return 'account.business';
    case 'm':
      return 'account.merchant';
    case 'gw':
      return 'account.gateway';
    case 'lpg':
      return 'account.lpg';
    default:
      return 'account.regular';
  }
};

const FullList = ({ t, accounts, loading }) => (
  <Table
    rowKey={(row, index) => index}
    columns={[
      {
        title: t('account.alias'),
        dataIndex: 'alias',
        render: (alias, record) => <Link to={`/accounts/${record.id}`}>{alias}</Link>,
      },
      {
        title: t('account.type'),
        dataIndex: 'product_id',
        render: (productId) => t(accountType(productId)),
      },
      {
        title: t('account.balance'),
        dataIndex: '',
        render: (record) => (<BalanceDisplayer account={record} />),
      },
      {
        title: '',
        dataIndex: '',
        width: 200,
        render: (record) => (
          <div>
            <Link to={`/accounts/${record.id}/transactions`}>{t('transactions')}</Link><Divider type="vertical" />
            <Link to={`/accounts/${record.id}/batches`}>{t('batches')}</Link>
          </div>
        ),
      },
    ]}
    dataSource={accounts}
    pagination={false}
    scroll={{ x: true }}
    loading={{
      indicator: LoadingIcon,
      size: 'large',
      spinning: loading || false,
    }}
  />
);

FullList.propTypes = {
  accounts: PropTypes.array,
  loading: PropTypes.bool,
  t: PropTypes.func,
};

const CompactList = ({ accounts, loading }) => (
  <List
    dataSource={accounts}
    bordered
    renderItem={(item) => (
      <List.Item
        key={item.id}
        actions={[
          <Link key="unordered-list" to={`/accounts/${item.id}/transactions`}><Icon type="unordered-list" /></Link>,
          <Link key="upload" to={`/accounts/${item.id}/batches`}><Icon type="upload" /></Link>,
        ]}
      >
        <List.Item.Meta
          title={(
            <>
              <Link to={`/accounts/${item.id}`}>{item.alias}</Link>
              <Divider type="vertical" />
              {item.region_id}
            </>
          )}
          description={(
            <>
              <BalanceDisplayer
                account={item}
                className="balance-flex-block"
                showUpdatedAt
              />
              <a
                className="item-url"
                href={item.url}
                rel="noopener noreferrer"
                target="_blank"
              >
                {item.url}
              </a>
            </>
          )}
        />
      </List.Item>
    )}
    loading={{
      indicator: LoadingIcon,
      size: 'large',
      spinning: loading || false,
    }}
  />
);

CompactList.propTypes = {
  accounts: PropTypes.array,
  loading: PropTypes.bool,
};

const AccountList = ({ full, ...props }) => {
  if (!!full) {
    return <FullList {...props} />;
  }

  return <CompactList {...props} />;
};

AccountList.propTypes = {
  full: PropTypes.bool,
};

const TranslatedAccountList = withTranslation()(AccountList);
export default TranslatedAccountList;
